const { extend } = require('underscore')
const {
  BRAND_GREEN,
  BRAND_BLUE,
  BRAND_GREY,
  SUBTLE_GREY,
  LIGHT_GREY,
  DARK_GREY
} = require('./colors')

const defaultOptions = {
  /**
   * Enables the chart to be animated on scroll.
   * @type {Boolean}
   */
  animateWhenVisible: false,

  /**
   * Sets animation duration. Works only with
   * animateWhenVisible set to true.
   * @type {Number}
   */
  animationDuration: 1000,

  /**
   * Set the chart part that should fit into
   * a viewport in order to launch animation.
   * @type {Number}
   */
  visibilityThreshold: 0.5,

  /**
   * Format of unit labels on the chart.
   * @type {String}
   */
  unitLabel: '{unit}',

  /**
   * Sets the threshold at which the chart starts rendering vertically.
   * Originally comes from 'front/apps/public/shared/styles/themes/_default.sass'
   * @type {Number}
   */
  narrowThreshold: 524,

  /**
   * Fixed height of a pie chart, pixels.
   * @type {Number}
   */
  pieChartHeight: 200,

  /**
   * Minimal height of a bar chart, pixels.
   * @type {Number}
   */
  minBarChartHeight: 150,

  /**
   * A height of a line (a bar with a label) in a bar chart.
   * @type {Number}
   */
  barLineHeight: 50,

  /**
   * A height of one item in a legend. Used for pie chart size calculation.
   * @type {Number}
   */
  legendLineHeight: 30,

  /**
   * Main colors are used for different sections of a chart.
   * @type {String}
   */
  colorFirst: BRAND_GREEN,
  colorSecond: BRAND_BLUE,
  colorThird: BRAND_GREY,

  /**
   * Auxiliary colors used to draw the grid and labels
   * @type {String}
   */
  colorGrid: SUBTLE_GREY,
  colorTicks: LIGHT_GREY,
  colorCategory: DARK_GREY,

  /**
   * Font settings
   */
  fontSizeBase: 14,
  fontSizeAux: 12,
  fontWeight: 100,
  fontFamily: '"Proxima Nova", sans-serif'
}

module.exports = overrides => extend({}, defaultOptions, overrides)



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/chart/config/index.js